import { ElDialog, ElIcon, ElCarousel, ElCarouselItem } from "element-plus";
import config from './../config';
import baseApp from './../../../plugins/baseApp';
import './../css/home.css';
import App from './App';
const vm = baseApp(App, config.schoolId);
vm.use(ElDialog).use(ElIcon).use(ElCarousel).use(ElCarouselItem);
vm.mount('#app');